module.exports = __webpack_public_path__ + "media/images/banners/2-97a033683c42a82dc5fe8294d200251b.png";